import { Component, input } from '@angular/core';

@Component({
  selector: 'app-m4td-boxes',
  imports: [],
  templateUrl: './m4td-boxes.html',
  styleUrl: './m4td-boxes.scss',
})
export class M4tdBoxes {
  boxes = input<any>()

}
